<template>
  <div class="flex items-start gap-3 max-w-[80%]">
    <div
      class="w-10 h-10 rounded-full bg-gray-100 dark:bg-gray-700 md:flex items-center justify-center text-2xl hidden"
    >
      🤖
    </div>
    <div class="px-4 py-3 rounded-2xl bg-gray-100 dark:bg-gray-700">
      <div class="typing-indicator flex items-center gap-1 py-1.5">
        <span class="dark:bg-gray-400"></span>
        <span class="dark:bg-gray-400"></span>
        <span class="dark:bg-gray-400"></span>
      </div>
    </div>
  </div>
</template>
